import { render, staticRenderFns } from "./ProductLicense.vue?vue&type=template&id=0b90c634"
import script from "./ProductLicense.vue?vue&type=script&lang=js"
export * from "./ProductLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports